import { Button, Loader } from "@mantine/core";
import "./SendEmailButton.scss";
import { useEmailStore } from "@components/Tax Pro Only/Modals/EmailModal/emailStore.ts";

const SendEmailButton = () => {
  const { isSending, sendEmail, isGenerating } = useEmailStore();
  const isBusy = isSending || isGenerating;

  return (
    <Button
      size="md"
      className="send-email-button"
      onClick={() => sendEmail()}
      data-testid="send-email-button"
      w={"8.5rem"}
      disabled={isBusy}
    >
      {isBusy ? <Loader color="#fff" size="xs" /> : "Send email"}
    </Button>
  );
};

export default SendEmailButton;
